import React from 'react';
import { TableRow, TableCell } from '@core-ui/Components/ui/table';
import { Skeleton } from '@core-ui/Components/ui/skeleton.tsx';

interface TableSkeletonRowsProps {
  rows: number;
}

export const TableSkeletonRows: React.FC<TableSkeletonRowsProps> = ({
  rows,
}) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex} className="border-border">
          {/* Name */}
          <TableCell>
            <Skeleton className="h-4 w-[160px] bg-muted-foreground/10 dark:bg-muted-foreground/20" />
          </TableCell>

          {/* Content */}
          <TableCell>
            <div className="space-y-2">
              <Skeleton className="h-4 w-[300px] bg-muted-foreground/10 dark:bg-muted-foreground/20" />
              <Skeleton className="h-4 w-[200px] bg-muted-foreground/10 dark:bg-muted-foreground/20" />
              <Skeleton className="h-4 w-[50px] bg-muted-foreground/10 dark:bg-muted-foreground/20" />
            </div>
          </TableCell>

          {/* Last Modified */}
          <TableCell>
            <Skeleton className="h-4 w-[100px] bg-muted-foreground/10 dark:bg-muted-foreground/20" />
          </TableCell>

          {/* Actions */}
          <TableCell>
            <div className="flex items-center justify-center gap-2">
              <Skeleton className="h-6 w-6 rounded-full bg-muted-foreground/10 dark:bg-muted-foreground/20" />
              <Skeleton className="h-6 w-6 rounded-full bg-muted-foreground/10 dark:bg-muted-foreground/20" />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
